import { useState } from "react";
import { useHistory } from "react-router-dom";
import InputField from "../../components/InputField/InpurField";
import withoutAuth from "../../services/withoutAuthProvider";
import toast from 'react-hot-toast';
import getHostSubdomain from "../../helpers/getHostSubdomain";
import { Spinner } from "react-bootstrap";

const Arrow = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5 15L7.5 10L12.5 5" stroke="#CF1701" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const LupaPassword = () => {
    const { push } = useHistory();
    const [email, setEmail] = useState('')
    const [error, setError] = useState([])
    const [message, setMessage] = useState(null)
    const [loading, setLoading] = useState(false)

    const hostFinalSubdomain = getHostSubdomain();


    const handleChange = (e) => {
        const { value } = e.target;
        setEmail(value);
    }

    const handleSubmit = async () => {
        setLoading(true);
        const loadingToast = toast.loading('Mengirimkan...');
        const body = { email };
        if (hostFinalSubdomain !== 'global') {
            body.subdomain = hostFinalSubdomain;
        }
        const response = await withoutAuth.postDataWithoutAuth('/api/password/send', body);
        toast.dismiss(loadingToast);
        if (response?.status === 200) {
            push('/lupa-password-berhasil', { email });
        } else {
            const msg = response?.data?.message;
            const errorMsg = typeof msg === 'object' && msg !== null && !Array.isArray(msg)
                ? Object.values(msg).join(' ')
                : msg ?? 'Terjadi kesalahan, silakan coba lagi';
            toast.error(errorMsg, { id: 'error-message', duration: 3000 });
            setLoading(false);
        }
    }

    return (
        <>
            <div className='w-100'>
                <div
                    className="d-flex align-items-center text-primary cursor-pointer fw-bold mb-3"
                    onClick={() => push('/masuk')}>
                    <Arrow />
                    <div className="ms-2">Kembali</div>
                </div>
                <p className="fw-bold fs-4 mb-2">Atur Ulang Kata Sandi</p>
                {/* <div className="d-inline-block my-3 " style={{ width: '160px', height: '160px', backgroundColor: '#F0F2F5' }}>

                </div> */}
                <div className='font-sm d-flex mb-3'>
                    <div className='me-2 text-secondary'>
                        Silakan isi email Anda yang sudah terdaftar lalu kami
                        <br />
                        akan mengirim intruksi untuk mengatur ulang kata sandi</div>
                </div>
                <div className='mb-3'>
                    <InputField
                        id='email'
                        name='email'
                        placeholder='Masukan Email Anda'
                        onChange={handleChange}
                        label='Email'
                        type="email"
                        value={email}
                        autoComplete='off'
                    />
                    {message && <div className='text-primary'>{message}</div>}
                </div>
                <div className="d-grid gap-2">
                    <button
                        className="btn btn-primary font-sm"
                        type="button"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                        Kirim
                    </button>
                </div>
            </div >
        </>
    )
}

export default LupaPassword;